import React, { Component } from 'react';

import { session } from '_helpers';
import { Loading } from '_components';

class LogoutPage extends Component {
  componentDidMount() {
    session.userManager.signoutRedirect();
  }

  render() {
    return (
      <Loading fullscreen />
    );
  }
}

export default LogoutPage;
